import "./styles.scss";
import { Loading } from "../../utils/loading";
import Card from "./card";
import SchedulingDetailDialog from "./dialogs/SchedulingDetailDialog";
import useCalendar from "../../hooks/useCalendar";
import { useState, useEffect } from "react";
import { Select, Button } from "@rio-cloud/rio-uikit";

const Calendar = () => {
  const {
    currentDate,
    showCalendar,
    setShowCalendar,
    showDialog,
    setShowDialog,
    schedulingChoosed,
    setSchedulingChoosed,
    loading,
    monthSchedule,
    changeMonth,
    renderDays,
    daysOfWeek,
    monthNames,
  } = useCalendar();

  return (
    <div>
      <span
        className="indicated-icon"
        onClick={() => setShowCalendar(!showCalendar)}
      >
        <span className="rioglyph rioglyph-calendar text-color-white !text-[30px]"></span>
      </span>

      {showCalendar && <>
        <div className="bg-calendar-sidebar" onClick={() => setShowCalendar(!showCalendar)} />
        <div className="calendar-sidebar dark:bg-[#1a1a1a]">
          <div className="flex justify-between padding-right-20 calendar-sidebar__header dark:bg-[#1a1a1a]">
            <h3 className="flex items-center gap-6 chat-sidebar__title text-color-map-marker-asset dark:text-[#31b5c0]">
              <span className="rioglyph rioglyph-calendar text-color-map-marker-asset dark:text-[#31b5c0]"></span>
              Calendário
            </h3>
            <div
              className="padding-top-20 close-sidebar cursor-pointer dark:bg-[#1a1a1a]"
              onClick={() => setShowDialog(!showDialog)}
            >
              <span className="rioglyph rioglyph-remove dark:text-[#31b5c0]"></span>
            </div>
          </div>

          <div className="calendar-container dark:bg-[#2a2a2a]">
            <div className="calendar-header dark:bg-[#2a2a2a]">
              <span  className="text-color-status-available text-normal text-size-16 hover:opacity-80 dark:text-white">
                {monthNames[currentDate.getMonth()]} {currentDate.getFullYear()}
              </span>
              
              {!loading && <div className="calendar-header__nav">
                <button
                  className="rioglyph rioglyph-chevron-left text-size-14 dark:text-[#31b5c0]"
                  onClick={() => changeMonth(-1)}
                />
                <button
                  className="rioglyph rioglyph-chevron-right text-size-14 dark:text-[#31b5c0]"
                  onClick={() => changeMonth(1)}
                />
              </div>}
            </div>
            <div className="calendar-days-of-week dark:bg-[#2a2a2a]">
              {daysOfWeek.map((day, index) => (
                <div key={index} className="calendar-day-name dark:text-white">
                  {day}
                </div>
              ))}
            </div>
            <div className="calendar-days dark:bg-[#2a2a2a]">{renderDays()}</div>
          </div>

          <div className="schedule-container dark:bg-[#1a1a1a]">
            <h3 className="flex items-center gap-4 chat-sidebar__title text-color-darker dark:text-[#31b5c0]">
              <div className="border-b w-full pb-1 dark:border-[#31b5c0]">
                <span className="rioglyph rioglyph-checkboxes text-color-darker dark:text-[#31b5c0]"></span>
                Agendamento
              </div>
            </h3>

            <div className="schedule-cards">
              {loading && <Loading label="Carregando agendamentos..." />}
              {!loading && monthSchedule
                .filter(
                  (scheduling) =>
                    scheduling.date.getDate() === currentDate.getDate()
                )
                .map((scheduling, index) => (
                  <Card
                    key={index}
                    setShowDialog={setShowDialog}
                    scheduling={scheduling}
                    chooseScheduling={() => setSchedulingChoosed(scheduling)}
                  />
                ))}
            </div>
          </div>
        </div>

        <SchedulingDetailDialog
          show={showDialog}
          onClose={() => setShowDialog(false)}
          scheduling={schedulingChoosed}
        />
      </>}
    </div>
  );
};

export default Calendar;
